import { render, staticRenderFns } from "./PrimitiveSelectTagModal.vue?vue&type=template&id=2776c367&"
import script from "./PrimitiveSelectTagModal.vue?vue&type=script&lang=js&"
export * from "./PrimitiveSelectTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports